// extracted by mini-css-extract-plugin
export var measureBox = "_bc-0";